import { useQuery } from "@apollo/client";
import React, { PropsWithChildren } from "react";
import { Routes, Route, useParams, Outlet } from "react-router-dom";
import { Viewer } from "components/auth/types";
import { isPropertyFeatureEnabled } from "pages/dashboard/interests";

import { Feature, SidebarFilters, SidebarFiltersVariables } from "types/gql-types";
import InterestProfileSlideout from "pages/dashboard/interests-profile-slideout/components/slideout";
import { QUERY_SIDEBAR_FILTERS } from "pages/dashboard/interests/interests-sidebar/query";
import SlideoutEnabledContext from "./context";

type Props = {
  list?: string;
  viewer: Viewer;
}

const WaitlistUpdateContainer: React.FC<PropsWithChildren<Props>> = (props) => {
  const { listId } = useParams();
  if (!listId) return <h4 className="text-center">No properties have opted into list updates.</h4>;
  const query = useQuery<
  SidebarFilters, SidebarFiltersVariables
  >(QUERY_SIDEBAR_FILTERS, { variables: { interestListIds: [listId] } });

  const features = query.data?.interestListsById[0].property.features || [];

  const slideoutEnabled = isPropertyFeatureEnabled(features, Feature.INTEREST_PROFILE_SLIDEOUT);
  return <SlideoutEnabledContext.Provider value={{ slideoutEnabled }}>
    <Outlet />
    {slideoutEnabled && (
      <Routes>
        <Route
          path="interests/:interestId/*"
          element={
            <InterestProfileSlideout
              viewer={props.viewer}
              listId={listId}
              sendFullAppToInterestsEnabled={false}
            />
          }
        />
        <Route
          path="contact/interests/:interestId/*"
          element={
            <InterestProfileSlideout
              viewer={props.viewer}
              listId={listId}
              sendFullAppToInterestsEnabled={false}
            />
          }
        />
        <Route
          path="process/:step/interests/:interestId/*"
          element={
            <InterestProfileSlideout
              viewer={props.viewer}
              listId={listId}
              sendFullAppToInterestsEnabled={false}
            />
          }
        />
      </Routes>
    )}
  </SlideoutEnabledContext.Provider>;

};
export default WaitlistUpdateContainer;
